<template>
<b-overlay :show="show" rounded="sm">
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4" v-if="load">
      <b-card-body class="p-12">
        <h1 tabindex="0">{{ form.titulo }}</h1>
        <b-row>
          <b-col cols="12">
            <div tabindex="0" v-html="form.descricao"></div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body class="mx-4" v-for="(proposta, index) in form.propostas"  :key="proposta.id">
      <b-card-body class="p-12">
        <b-row>
          <b-col cols="12">
            <div tabindex="0" v-html="proposta.texto"></div>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="6">
            <b-button block variant="secondary"  @click="loadModalSugestaoEdicao(index)">
              <i class="fa fa-pencil"></i>&nbsp;
              <span>Visualizar Sugestão</span>
              <span class="badge badge-light">{{ proposta.totalSugestoesAlteracao }}</span>
            </b-button>
          </b-col>
           <b-col  md="6">
            <b-button block variant="secondary"  @click="loadModalPriorizar(index)">
              <i class="fa fa-check"></i>&nbsp;
              <span>Visualizar Priorização</span>
              <span class="badge badge-light">{{ proposta.totalPriorizacao }}</span>
            </b-button>
          </b-col>
        </b-row><br>
        <b-row>
          <b-col md="6">
            <b-button block variant="secondary"  @click="loadModalAprovarOriginal(index)">
              <i class="fa fa-check"></i>&nbsp;
              <span >Visualizar Aprovados</span>
              <span class="badge badge-light">{{ proposta.totalVotacaoOriginal }}</span>
            </b-button>
          </b-col>
          <b-col md="6">
            <b-button block variant="secondary"  @click="loadModalAprovarAlterado(index)">
              <i class="fa fa-check"></i>&nbsp;           
              <span>Visualizar Rejeições</span>
              <span class="badge badge-light">{{ proposta.totalVotacaoAlterado }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
    <b-card no-body class="mx-4">
       <b-row>
          <b-col cols="12">
            <div style="background-color: #FAAF40; padding-top: 5px; padding-bottom: 1px;">
              <p tabindex="0" style="font-size: 16px"><strong>Comentários</strong></p>
            </div>
            <b-card style="height: 300px; overflow: auto;">
              <ul v-if="form.comentarios.length  > 0">
                <li v-for="comentario in form.comentarios" :key="comentario.id">
                  <p tabindex="0"><strong>{{ comentario.user.nome }} - {{ comentario.created_at }}</strong></p>
                  <p tabindex="0">{{ comentario.texto }}</p>
                </li>
              </ul>
              <ul v-else>
                <li>
                  <i tabindex="0">Nenhum comentário registrado.</i>
                </li>
              </ul>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col tabindex="0" cols="2">
            <strong>Comentário:</strong>
          </b-col>
          <b-col cols="10">
            <b-form-textarea tabindex="0" id="textarea" rows="8" v-model="comentario"></b-form-textarea>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col cols="4">
            <b-button block variant="secondary" @click="loadModalComentarios()">
              <i class="fa fa-plus"></i>&nbsp;&nbsp;<span>Adicionar Comentário</span>
            </b-button>
          </b-col>
        </b-row> -->
    </b-card>
    <b-card no-body class="mx-4">
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3">
            <b-button block variant="secondary" @click="navigate('/proposta')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>

    <b-modal title="Sugerir Alteração de Texto" size="lg" @ok="cancelar()" ok-only v-model="modalSugestaoEdicao">
      <b-card-body>
        <b-row>
          <b-col cols="4">
            <strong tabindex="0">Texto Atual:</strong>
          </b-col>
          <b-col cols="8">
            <div tabindex="0" v-html="textoAtualSugestao" />
          </b-col>
        </b-row>
        <hr>
        <b-form>
          <span v-if="edicoes.data !== undefined">
            <b-row v-for="edicao in edicoes.data" :key="edicao.id">
              <b-col md="12" sm="12">
                <b-card no-body>
                  <b-card-body class="p-12">
                    <b-row>
                      <b-col tabindex="0" cols="9">
                        <strong>Usuário: </strong> {{ edicao.nome_social ? edicao.nome_social : edicao.usuario }}
                      </b-col>
                      <b-col tabindex="0" cols="3">
                        <i>{{ edicao.created_at }}</i>
                      </b-col>
                    </b-row>
                    <b-row style="margin-top: 10px">
                      <b-col tabindex="0" cols="4">
                        <strong>Sugestão de Alteração</strong>
                      </b-col>
                      <b-col cols="8">
                        <div tabindex="0" v-html="edicao.texto_sugerido"></div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4">
                        <b-button v-if="usuarioAtual == edicao.user_id" class="btn btn-sm btn-secondary action" title="Excluir" @click="excluirSugestao(edicao.id, 'A')">
                          <i class="fa fa-trash"></i>
                          Excluir sugestão
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </span>
          <pagination tabindex="0" v-show="edicoes.data !== undefined" :totalPorPagina="5" :resource="resourceSugestao" :filtros="filtros"></pagination>
        </b-form>
      </b-card-body>
    </b-modal>

    <b-modal title="Visualizar Votação" size="lg" v-model="modalAprovarOriginal" @ok="cancelar()" ok-only>
      <b-card-body>
        <b-row>
          <b-col cols="12">
            <div tabindex="0" v-html="propostaOriginal.texto" />
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="12" style="text-align: center">
            <h5 tabindex="0"><strong>Aprovada Por</strong></h5>
          </b-col>
        </b-row>
        <hr>
        <b-form>
          <span v-if="avaliacoes.data !== undefined">
            <b-row>
              <b-col tabindex="0" md="12" sm="12">
                <ul>
                  <li v-for="(avaliacao) in avaliacoes.data" :key="avaliacao.id">
                    {{ avaliacao.nome_social ? avaliacao.nome_social : avaliacao.usuario }} - {{ avaliacao.created_at }}
                  </li>
                </ul>
              </b-col>
            </b-row>
          </span>
          <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
          <pagination tabindex="0" v-show="avaliacoes.data !== undefined" :totalPorPagina="5" :resource="resourceAvaliacoes" :filtros="filtros"></pagination>
        </b-form>
      </b-card-body>
    </b-modal>

    <b-modal title="Visualizar Priorização" size="lg" v-model="modalPriorizar" @ok="cancelar()" ok-only>
      <b-card-body>
        <b-row>
          <b-col cols="12">
            <div tabindex="0" v-html="propostaPrioriazada.texto" />
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="12" style="text-align: center">
            <h5 tabindex="0"><strong>Priorizada Por</strong></h5>
          </b-col>
        </b-row>
        <hr>
        <b-form>
          <span v-if="avaliacoes.data !== undefined">
            <b-row>
              <b-col tabindex="0" md="12" sm="12">
                <ul>
                  <li v-for="(avaliacao) in avaliacoes.data" :key="avaliacao.id">
                    {{ avaliacao.nome_social ? avaliacao.nome_social : avaliacao.usuario }} / {{ avaliacao.uf }} - {{ avaliacao.created_at }}
                  </li>
                </ul>
              </b-col>
            </b-row>
          </span>
          <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
          <pagination tabindex="0" v-show="avaliacoes.data !== undefined" :totalPorPagina="5" :resource="resourceAvaliacoes" :filtros="filtros"></pagination>         
        </b-form>
      </b-card-body>
    </b-modal>

    <b-modal title="Visualizar Votação" size="lg" v-model="modalAprovarAlterado" @ok="cancelar()" ok-only>
      <b-card-body>
        <b-row>
          <b-col cols="12">
            <div tabindex="0" v-html="propostaAlterada.texto" />
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="12" style="text-align: center">
            <h5 tabindex="0"><strong>Aprovada Por</strong></h5>
          </b-col>
        </b-row>
        <hr>
        <b-form>
          <span v-if="avaliacoes.data !== undefined">
            <b-row>
              <b-col tabindex="0" md="12" sm="12">
                <ul>
                  <li v-for="(avaliacao) in avaliacoes.data" :key="avaliacao.id">
                    {{ avaliacao.nome_social ? avaliacao.nome_social : avaliacao.usuario }} / {{ avaliacao.uf }} - {{ avaliacao.created_at }}
                  </li>
                </ul>
              </b-col>
            </b-row>
          </span>
          <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
          <pagination tabindex="0" v-show="avaliacoes.data !== undefined" :totalPorPagina="5" :resource="resourceAvaliacoes" :filtros="filtros"></pagination>
        </b-form>
      </b-card-body>
    </b-modal>

    <b-modal title="Incluir Comentários" size="lg" cancel-title="Cancelar" v-model="modalComentario" @ok="enviarComentario()">
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <h3 tabindex="0" style="color: #339966; margin-bottom: 20px; font-weight: bold; text-align: center">Insira aqui seu Comentário</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col tabindex="0" cols="2">
              <strong>Comentário:</strong>
            </b-col>
            <b-col cols="10">
              <b-form-textarea tabindex="0" id="textarea" rows="8" v-model="comentario"></b-form-textarea>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
  </b-col>
</b-overlay>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import {eventType} from '@/components/shared/eventType'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    Pagination,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
        required
      }
    }
  },
  created () {
    if (!this.can('proposta.show')) {
      // this.$router.push('/')
    }
    this.loadCaderno(this.$route.params.id)
  },
  data () {
    return {
      loading: false,
      show: false,
      form: {
        id: '',
        titulo: '',
        descricao: '',
        eixo: '',
        propostas: [],
        comentarios: []
      },
      filtros: {
        tipo: null
      },
      load: false,
      propostaAtual: null,
      modalComentario: false,
      modalPriorizar: false,
      textoAtualSugestao: '',
      sugestaoEdicao: '',
      comentario: '',
      resourceSugestao: '',
      resourceComentario: '',
      resourceAvaliacoes: '',
      modalSugestaoEdicao: false,
      modalAprovarOriginal: false,
      modalAprovarAlterado: false,
      propostaPrioriazada: [],
      propostaOriginal: [],
      propostaAlterada: [],
      usuarioAtual: 0,
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  computed: {
    avaliacoes () {
      return this.$store.state.pagination.getList
    },
    edicoes () {
      return this.$store.state.pagination.getList
    },
    exclusoes () {
      return this.$store.state.pagination.getList
    },
    comentarios () {
      return this.$store.state.pagination.getList
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    loadModalComentarios () {
      this.modalComentario = true
      this.comentario = ''
    },
    loadModalSugestaoEdicao (index) {
      this.resourceSugestao = 'proposta/' + this.form.propostas[index].id + '/sugestao'
      this.propostaAtual = this.form.propostas[index].id
      this.textoAtualSugestao = this.form.propostas[index].texto
      this.sugestaoEdicao = ''
      this.modalSugestaoEdicao = true
      this.filtros.tipo = 'A'
    },
    loadModalPriorizar (index) {
      this.resourceAvaliacoes = 'proposta/' + this.form.propostas[index].id + '/visualizar/avaliacao'
      this.propostaAtual = this.form.propostas[index].id
      this.filtros.proposta_original = true
      this.modalPriorizar = true
      this.propostaPrioriazada = this.form.propostas[index]
    },
    loadModalAprovarOriginal (index) {
      this.resourceAvaliacoes = 'proposta/' + this.form.propostas[index].id + '/avaliacao'
      this.propostaAtual = this.form.propostas[index].id
      this.filtros.proposta_original = true
      this.modalAprovarOriginal = true
      this.propostaOriginal = this.form.propostas[index]
      console.log(this.propostaOriginal)
    },
    loadModalAprovarAlterado (index) {  
      this.resourceAvaliacoes = 'proposta/' + this.form.propostas[index].id + '/avaliacao'
      this.propostaAtual = this.form.propostas[index].id
      this.filtros.proposta_original = false
      this.modalAprovarAlterado = true
      this.propostaAlterada = this.form.propostas[index]
    },
    loadCaderno (id) {
      Vue.http.get('api/proposta/' + id).then(response => {
        let data = response.body.data
        this.form.id = data.id
        this.form.titulo = data.titulo
        this.form.descricao = data.descricao
        this.form.eixo = data.eixo
        this.form.propostas = data.propostas
        this.form.comentarios = data.comentarios
        this.load = true
      })
    },
    enviarComentario () {
      this.$bvModal.msgBoxConfirm('Confirma o envio do comentário?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          let data = {
            texto: this.comentario,
            caderno_proposta_id: this.form.id
          }          
          Vue.http.post('api/proposta/' + this.form.id + '/comentario', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.modalComentario = false
              this.comentario = ''
              this.loadCaderno(this.form.id)
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    enviarSugestaoEdicao () {
      this.$bvModal.msgBoxConfirm('Confirma o envio da sugestão de alteração?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          let data = {
            tipo: 'A',
            texto_atual: this.textoAtualSugestao,
            texto_sugerido: this.sugestaoEdicao
          }

          Vue.http.post('api/proposta/' + this.propostaAtual + '/sugestao', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.modalSugestaoEdicao = false
              this.propostaAtual = ''
              this.textoAtualSugestao = ''
              this.sugestaoEdicao = ''
              this.loadCaderno()
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    excluirSugestao (id, tipo) {
      this.$bvModal.msgBoxConfirm('Confirma a exclusão da sugestão?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          Vue.http.delete('api/proposta/' + id + '/sugestao', {}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resourceSugestao, limit: 5, filtros: {tipo: tipo}})
              this.loadRegimento(this.$route.params.id)
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/caderno/PropostaVisualizar.vue